import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import { CommunityCard } from "../../cards/community-card"
import { events } from "../../../constants/analytics"
import ButtonLink from "../../../ui/button-link"
import cn from "../../../utils/classname"
import { capture } from "../../../services/posthog"

const Community = () => {
  const { discourseTopics } = useStaticQuery(graphql`
    {
      discourseTopics: allDiscourseTopic(sort: { activity: DESC }, limit: 6) {
        nodes {
          title
          repliesCount: replies
          activityFromNow: activity(fromNow: true)
          slug
          topicId
          tags
          views
          user {
            userId
            username
            avatarUrl
          }
        }
      }
    }
  `)

  return (
    <div className="container-lg mt-[100px] sm:mt-[120px] flex flex-col gap-10">
      <div className="flex flex-wrap gap-4 justify-between">
        <div className="flex flex-col gap-1">
          <div className="text-jar-6 font-semibold text-neutral-12">
            Join our community of developers
          </div>
          <div className="text-jar-4 text-neutral-11">
            Create a free account and join our community today!
          </div>
        </div>
        <div>
          <ButtonLink
            size={2}
            contrast={"high"}
            weight={"medium"}
            theme={"neutral"}
            underline={true}
            id="banner-community-link"
            href="/community/"
            external
            onClick={() => {
              capture(events.clicked_go_to_community)
            }}
          >
            Browse the forum
          </ButtonLink>
        </div>
      </div>
      <div className="w-[calc(100%+32px)] lg:w-full -mx-4 lg:mx-0 overflow-x-hidden">
        <div
          className={cn(
            "flex overflow-auto gap-2 lg:flex-col px-4 lg:px-0 snap-x snap-mandatory",
            "pb-5 lg:pb-0"
          )}
        >
          {discourseTopics.nodes.map(
            ({
              title,
              repliesCount,
              activityFromNow,
              slug,
              topicId,
              user,
              tags,
              views,
            }) => (
              <CommunityCard
                key={`${topicId}-${slug}`}
                description={title}
                repliesCount={repliesCount}
                activityFromNow={activityFromNow}
                user={{
                  avatar: user.avatarUrl,
                  name: user.username,
                }}
                slug={slug}
                topicId={topicId}
                tags={tags}
                views={views}
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default Community
